import * as React from 'react';
const SvgELearning = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M75.548 69.742v42.581l11.613-9.678L98.774 122l9.678-5.806-11.613-19.355 13.548-3.871-34.839-23.226ZM110.387 36.839H40.709v11.613h69.678V36.839Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.935 87.161H40.71V60.065h69.678v19.354M13.613 60.065h15.484M13.613 36.839h15.484"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.935 102.645H5.871A3.87 3.87 0 0 1 2 98.775V5.87A3.87 3.87 0 0 1 5.871 2h112.258A3.87 3.87 0 0 1 122 5.871v90.968a3.87 3.87 0 0 1-3.871 3.871h-3.871M2 21.355h120"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.677 11.678h3.871M21.355 11.678h3.87M31.032 11.678h3.871"
      stroke="#000"
      strokeWidth={4}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgELearning;
